/** Délai debounce standard en millisecondes */
export const DEBOUNCE_MS = 300

/** TTL du cache en millisecondes (10 minutes) */
export const CACHE_TTL_MS = 600000